import { render, staticRenderFns } from "./CogView.vue?vue&type=template&id=051a6da0"
import script from "./CogView.vue?vue&type=script&lang=js"
export * from "./CogView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports